<template>
    <form class="form-horizontal" v-if="config">
        <div class="form-group">
            <label for="ip_primario" class="col-sm-2 control-label">IP 1:</label>
            <div class="col-sm-3">
                <input type="text" v-model="config.ip_primario" class="form-control" id="ip_primario">
            </div>
            <label for="porta_primario" class="col-sm-2 control-label">PORTA:</label>
            <div class="col-sm-2">
                <input type="text" v-model="config.porta_primario"  class="form-control" id="porta_primario" >
            </div>
        </div>
        <div class="form-group">
            <label for="ip_secundario" class="col-sm-2 control-label">IP 2:</label>
            <div class="col-sm-3">
                <input type="text" v-model="config.ip_secundario" class="form-control" id="ip_secundario">
            </div>
            <label for="porta_secundario" class="col-sm-2 control-label">PORTA:</label>
            <div class="col-sm-2">
                <input type="text" v-model="config.porta_secundario"  class="form-control" id="porta_secundario" >
            </div>
        </div>
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <button @click="send()" type="button" class="btn btn-xs btn-success">
                    <i class="fa fa-save"></i> ENVIAR CONFIGURAÇÃO
                </button>
            </div>
        </div>
    </form>
</template>
<script>
    import {Suntech} from "../../../../../class";
    import {Bus} from '../../../../../class/bus';
    export default {
        name: "Conexao4G",
        props: {
            config: {
                "default": null
            }
        },
        methods: {
            send () {
                swal({
                    title: 'Posso Confirmar?',
                    text: "Deseja realmente enviar esta configuração?",
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, pode enviar!'
                }).then(async () => {
                    try {
                        await Suntech.sendConexao(this.config);
                        Bus.$emit('comandos');
                        toastr.success("Configuração enviada!");
                    } catch (err) {
                        console.log(err);
                        return toastr.error("Conexao não enviada!");
                    }
                });
            }
        }
    }
</script>
